import type { Conversation } from '@customTypes/chat';
import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type GetConversationsListParams = {
  chatProfileId: number;
};

export const getConversationsList = async ({
  params,
  config
}: RequestConfig<GetConversationsListParams>) =>
  api.get<Conversation[]>(
    `/api/chat/conversations/${params.chatProfileId}`,
    config
  );
